import React from 'react';
import ReactDOM from 'react-dom';
import AppRouting from './route/app.route';
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer, toast, Slide } from "react-toastify";
import store from "./redux/store";
import * as serviceWorker from './serviceWorker';

import "react-toastify/dist/ReactToastify.css";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './asset/styles/style.scss';
import 'mapbox-gl/dist/mapbox-gl.css';

import mapboxgl from 'mapbox-gl';
mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js');

const App = () => (
    <ReduxProvider store={store}>
      <AppRouting />
      <ToastContainer
          position={toast.POSITION.BOTTOM_LEFT}
          autoClose={3000}
          hideProgressBar={false}
          limit={3}
          transition={Slide}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
      />
    </ReduxProvider>
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
